/**
 * Echo mobile app store listings. The Apple URL names no storefront, so it
 * opens the visitor's own.
 */
export const APP_STORE_URL = "https://apps.apple.com/app/id6738379152";

export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.elevate_aviation";

/** The same listings keyed by store, for components that take a `store` prop. */
export const STORE_URLS = {
  googlePlay: GOOGLE_PLAY_URL,
  appStore: APP_STORE_URL,
};

export const YOUTH_PROGRAM_URLS = {
  aceOnTour: "https://www.elevateaviation.ca/starters/ace-on-tour/",
  careerExploration:
    "https://learn.elevateaviation.ca/programs/aviation-career-exploration/",
  juniorJets: "https://learn.elevateaviation.ca/programs/junior-jets/",
  aviationBirthdayParties:
    "https://learn.elevateaviation.ca/programs/aviation-career-exploration/birthdays/",
};
